import { Inject, Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { CacheService } from "ionic-cache";
import { ConversationsProviderEvent } from "../..";
import { AuthenticationModel, AuthenticationProvider, AuthenticationProviderEvent, ChatConverter, ChatEndPoints, CheckUtils, ConversationsMessagesProvider, ConversationsProvider, ConversationsSettingsModel, ConversationsStatisticsProvider, ConversationStateVoData, ConversationStatusVoData, ConversationUserStatisticsVoData, DeanonymizeUserApiData, FilesProvider, FileVoData, Guid, JabberCustomMessageData, JabberEndPoints, JabberEPEvent, JabberExtension, JabberJidVoData, JabberPropertiesData, JabberSendChatStateData, JabberTypeVoData, logger, MessageSourceVoData, MessageVoData, OdConfig, OrganizationModel, UpdateModelVoData, UserResolverVoData, UsersProvider, UsersResolverModel } from "../..";
import { JabberCustomTypeData } from "../../end-points-dto/jabber-dto/jabber-custom-type-data";
import { MessengerInviteVoConverter } from "../../end-points-vos-converters/jabber-vos-converters/messenger/messenger-invite-vo-converter";
import { FilesConverter } from "../../utils/converter/files-converter";
var JabberProvider = /** @class */ (function () {
    function JabberProvider(config, events, cache, chatEndPoints, jabberEndPoints, conversationsProvider, messagesProvider, usersProvider, _filesProvider, _usersResolverModel, _conversationsSettingsModel, _conversationsStatisticsProvider, _modelAuth, _usersProvider, _authProvider, _modelOrg) {
        this.config = config;
        this.events = events;
        this.cache = cache;
        this.chatEndPoints = chatEndPoints;
        this.jabberEndPoints = jabberEndPoints;
        this.conversationsProvider = conversationsProvider;
        this.messagesProvider = messagesProvider;
        this.usersProvider = usersProvider;
        this._filesProvider = _filesProvider;
        this._usersResolverModel = _usersResolverModel;
        this._conversationsSettingsModel = _conversationsSettingsModel;
        this._conversationsStatisticsProvider = _conversationsStatisticsProvider;
        this._modelAuth = _modelAuth;
        this._usersProvider = _usersProvider;
        this._authProvider = _authProvider;
        this._modelOrg = _modelOrg;
        this.jabberEndPoints.addExtension(JabberExtension.adminMessage);
        this._reconnectCount = 0;
        this.setup();
        this.bind();
    }
    JabberProvider.prototype.setup = function () {
        var _this = this;
        this._sendingMessages = [];
        this.cache.getNetworkStatusChanges().subscribe(function (res) {
            if (res) {
                logger.warn("Network is connecting");
                if (!_this.jabberEndPoints.isConnecting) {
                    _this._handleConnected();
                    _this.jabberEndPoints.connect();
                }
            }
            else {
                logger.warn("Network is disconnecting");
            }
        });
        this._signInHandler = function (res) {
            if (res && _this._modelAuth.userId != null && _this._modelAuth.jid != null && _this._modelAuth.jid.bare != null) {
                _this._usersResolverModel.add(new UserResolverVoData(_this._modelAuth.userId, _this._modelAuth.jid.bare));
            }
            if (CheckUtils.isEmpty(_this._modelAuth.authenticationToken)) {
                _this.signIn();
            }
            else {
                if (CheckUtils.isEmpty(_this._modelAuth.jid)) {
                    _this.getDefaultJID();
                }
                else {
                    _this.usersProvider.resolveJidsToUserVo([_this._modelAuth.jid.bare], function (users) {
                        if (!users.has(_this._modelAuth.jid.bare) || users.get(_this._modelAuth.jid.bare).externalId !== _this._modelAuth.jid.local) {
                            _this.chatEndPoints.deanonymizeUser(new DeanonymizeUserApiData(_this._modelAuth.jid.bare, _this._modelAuth.authenticationToken));
                        }
                        _this.getDefaultJID();
                    });
                }
            }
        };
        this._jidChangedHandler = function (res) { return _this._modelAuth.setJid(ChatConverter.convertToJidVoData(res)); };
    };
    JabberProvider.prototype.bind = function () {
        var _this = this;
        this.events.subscribe(AuthenticationProviderEvent.SIGNED, this._signInHandler);
        this.events.subscribe(JabberEPEvent.RECONNECTED, function () { return _this.signIn(); });
        /* After try to authentification, try to get default user jid  and sign in*/
        this.events.subscribe(JabberEPEvent.JID_CHANGED, this._jidChangedHandler);
        /* After jabber sign in, save full jid or jabber sign out and sign in as anonymous  */
        this.jabberEndPoints.onChatStateChange().subscribe(function (res) {
            if (CheckUtils.isEmpty(res))
                return;
            _this.conversationsProvider.get(new Set([res.from.bare]), function (conversations) {
                if (CheckUtils.isEmpty(conversations))
                    return;
                for (var _i = 0, conversations_1 = conversations; _i < conversations_1.length; _i++) {
                    var conversation = conversations_1[_i];
                    if (conversation.uid === _this.conversationsProvider.model.current) {
                        _this.events.publish(JabberEPEvent.CHAT_STATE_CHANGED, res.from.resource, res.chatState);
                    }
                }
            });
        });
        /* After receive a message, check if conversation & message exist, create on or change change status */
        this.jabberEndPoints.onMessage().subscribe(function (res) {
            if (CheckUtils.isEmpty(res))
                return;
            if (_this.config.jabberAdminSender === res.from.bare) {
                if (!CheckUtils.isEmpty(res.customData) &&
                    !CheckUtils.isEmpty(res.customData.properties)) {
                    var type_1 = undefined;
                    var roomId_1 = undefined;
                    var value_1 = undefined;
                    res.customData.properties.forEach(function (property) {
                        if ((property.name === "roomJid" || property.name === "authenticationToken") &&
                            property.value != null && typeof property.value === "string") {
                            roomId_1 = property.value;
                        }
                        else if (property.name === "type" && property.value != null) {
                            type_1 = property.value;
                        }
                        else if (property.name === "value" && property.value != null && typeof property.value === "string") {
                            value_1 = property.value;
                        }
                    });
                    if (type_1 === JabberCustomTypeData.AUTH_TOKEN) {
                        if (roomId_1 != null) {
                            _this.events.publish(_this._authProvider.model.event.TOKEN_LOADED, value_1);
                        }
                    }
                    else if (type_1 === JabberCustomTypeData.ROOM_LOCKED) {
                        if (roomId_1 != null && value_1 != null) {
                            _this.events.publish(ConversationsProviderEvent.LOCK, value_1 === "true");
                        }
                    }
                }
            }
            else {
                _this.conversationsProvider.get(new Set([res.from.bare]), function (conversations) {
                    if (CheckUtils.isEmpty(conversations))
                        return;
                    var message = _this.messagesProvider.model.get(res.id);
                    var filesId = [];
                    if (CheckUtils.isEmpty(message)) {
                        if (!CheckUtils.isEmpty(res.customData) &&
                            !CheckUtils.isEmpty(res.customData.properties)) {
                            res.customData.properties.forEach(function (property) {
                                if ((property.name === "isEdited" || property.name === "isDeleted") && property.value != null) {
                                    return;
                                }
                                else if (property.name === "attachments" && property.value != null) {
                                    var files = [];
                                    for (var _i = 0, _a = property.value; _i < _a.length; _i++) {
                                        var attachment = _a[_i];
                                        filesId.push(attachment.identityKey);
                                        files.push(new FileVoData(attachment.identityKey, attachment.name, attachment.contentType));
                                    }
                                    _this._filesProvider.model.addAll(files);
                                }
                            });
                        }
                        message = ChatConverter.convertJabberToMessageVoData(res);
                        message.valid = true;
                        message.files = filesId;
                        if (conversations[0].unReadMessagesId == null)
                            conversations[0].unReadMessagesId = [];
                        conversations[0].unReadMessagesId.push(message.uid);
                        _this.conversationsProvider.model.update(conversations[0].uid, [new UpdateModelVoData("unReadMessagesId", conversations[0].unReadMessagesId)]);
                        _this.messagesProvider.addMessages(conversations[0], [message]);
                        _this.messagesProvider.model.add(message);
                    }
                    else {
                        if (!CheckUtils.isEmpty(res.customData) &&
                            !CheckUtils.isEmpty(res.customData.properties)) {
                            res.customData.properties.forEach(function (property) {
                                if (property.name === "isEdited") {
                                    _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("isEdited", property.value)]);
                                }
                                else if (property.name === "isDeleted") {
                                    _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("isDeleted", property.value)]);
                                }
                                else if (property.name === "attachments" && property.value != null) {
                                    message.files = [];
                                    var files = [];
                                    for (var _i = 0, _a = property.value; _i < _a.length; _i++) {
                                        var attachment = _a[_i];
                                        message.files.push(attachment.identityKey);
                                        files.push(new FileVoData(attachment.identityKey, attachment.name, attachment.contentType));
                                    }
                                    _this._filesProvider.model.addAll(files);
                                    _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("files", message.files)]);
                                }
                            });
                        }
                        _this._sendingMessages = _this._sendingMessages.filter(function (item) { return item != message; });
                        if (message.valid) {
                            if (res.delay != null && res.delay.stamp != null && message.createdDate < res.delay.stamp.getTime()) {
                                _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("data", res.body)]);
                            }
                            else {
                                _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("createdDate", res.delay.stamp.getTime())]);
                            }
                        }
                        else {
                            if (res.delay != null && res.delay.stamp != null && message.createdDate !== res.delay.stamp.getTime()) {
                                _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("createdDate", res.delay.stamp.getTime())]);
                            }
                            if (res.from.resource === _this._modelAuth.jid.bare) {
                                _this.sendToAdmin(res);
                                message.valid = true;
                                _this.messagesProvider.model.update(message.uid, [new UpdateModelVoData("valid", message.valid)]);
                            }
                        }
                    }
                    _this._conversationsStatisticsProvider.change(conversations[0], message);
                });
            }
        });
        this.jabberEndPoints.onInvite().subscribe(function (res) {
            if (!CheckUtils.isEmpty(res) && !CheckUtils.isEmpty(res.room)) {
                var conversation_1 = null;
                if ((_this.conversationsProvider.model.has(res.room.bare)))
                    conversation_1 = _this.conversationsProvider.model.get(res.room.bare);
                if (CheckUtils.isEmpty(conversation_1)) {
                    conversation_1 = _this.conversationsProvider.create(_this.jabberEndPoints.getRoom(res.room.bare));
                    _this.conversationsProvider.model.add(conversation_1);
                }
                if (conversation_1.uid === _this.conversationsProvider.model.current) {
                    var parser = new DOMParser();
                    var xml = parser.parseFromString(res.reason, "text/xml");
                    logger.info("jabberEndPoint - is now invite to: " + res.reason + " on room " +
                        ((res.room == null) ? "undefined" : res.room.bare));
                    var messengerInviteVo = MessengerInviteVoConverter.convertDtoToInviteVo(res, xml.firstElementChild);
                    _this.events.publish(JabberEPEvent.INVITED_REASON, messengerInviteVo);
                }
                else {
                    _this.join(conversation_1);
                    logger.info("Join room " + res.room.bare + " for 5 seconds");
                    setTimeout(function () {
                        if (_this.conversationsProvider.model.current !== conversation_1.uid) {
                            _this.leave(conversation_1);
                            logger.info("Leave room " + res.room.bare + " after 5 seconds");
                        }
                    }, 5000);
                    _this.events.publish(JabberEPEvent.INVITED, conversation_1);
                }
            }
        });
    };
    JabberProvider.prototype.getDefaultJID = function () {
        var _this = this;
        this.chatEndPoints.defaultUserJid(this._modelAuth.authenticationToken).then(function (res) {
            if (_this._modelAuth.userId < 0 && _this._modelAuth.authenticationToken != null) {
                var oldJid = _this._modelAuth.jid;
                _this._usersProvider.model.delete(_this._modelAuth.userId);
                _this._modelAuth.setUserId(null, true);
                _this._usersResolverModel.delete(oldJid.bare);
            }
            _this._modelAuth.setJid(new JabberJidVoData(res, false));
            if (_this._modelAuth.userId == null) {
                _this.usersProvider.resolveJids(new Set([res]), function (res1) {
                    if (res1 != null && res1.has(res)) {
                        _this._modelAuth.setUserId(res1.get(res).userId);
                        _this._usersResolverModel.add(new UserResolverVoData(_this._modelAuth.userId, _this._modelAuth.jid.bare));
                        _this._authProvider.sendSignIn();
                        _this._usersProvider.get(new Set([_this._modelAuth.userId]), function (users) {
                            var user = null;
                            if (CheckUtils.isEmpty(users)) {
                                logger.warn("JabberProvider - user is undefined");
                            }
                            else {
                                user = users.get(_this._modelAuth.userId);
                                logger.info("JabberProvider - user signed as userid:" + user.id);
                            }
                            _this.events.publish(AuthenticationProviderEvent.USER_SIGNED, user);
                        });
                        _this.signIn();
                    }
                });
            }
            else {
                _this.signIn();
            }
        }).catch(function (err) {
            _this.signIn();
            logger.info(err);
        });
    };
    JabberProvider.prototype.join = function (conversation) {
        if (conversation != null) {
            this.jabberEndPoints.joinRoom(conversation, this._modelAuth.jid, {
                joinMuc: {
                    history: {
                        maxstanzas: 0
                    }
                }
            });
            return true;
        }
        return false;
    };
    JabberProvider.prototype.leave = function (conversation) {
        if (conversation != null)
            this.jabberEndPoints.leaveRoom(conversation, this._modelAuth.jid, {
                joinMuc: {
                    history: {
                        maxstanzas: 0
                    }
                }
            });
    };
    JabberProvider.prototype.signIn = function () {
        if (this._modelAuth.authenticationToken == null) {
            if (this._modelAuth.jid == null) {
                this.jabberEndPoints.signIn(this.config.jabberAnonymous);
            }
            else {
                this.jabberEndPoints.signIn(this._modelAuth.jid, Guid.guid());
            }
        }
        else {
            this.jabberEndPoints.signIn(this._modelAuth.jid, this._modelAuth.authenticationToken);
        }
        // if (!this.jabberEndPoints.isConnecting) {
        this._handleConnected();
        this.jabberEndPoints.connect();
        // }
    };
    JabberProvider.prototype.signOut = function () {
        this.jabberEndPoints.signOut();
    };
    JabberProvider.prototype.getNewMessageJabberId = function () {
        return this.jabberEndPoints.getNewMessageJabberId();
    };
    JabberProvider.prototype.getNewConversationJabberId = function () {
        return Guid.guid() + this.config.jabberConference;
    };
    JabberProvider.prototype.getConversation = function (callback) {
        if (CheckUtils.isEmpty(this.conversationsProvider.model.current)) {
            var conversation = this.conversationsProvider.create(this.jabberEndPoints.getRoom(this.getNewConversationJabberId()));
            callback(conversation);
        }
        else {
            this.conversationsProvider.get(new Set([this.conversationsProvider.model.current]), function (res) {
                callback(((CheckUtils.isEmpty(res)) ? null : res[0]));
            });
        }
    };
    JabberProvider.prototype.sendChatState = function (value) {
        var _this = this;
        if (!CheckUtils.isEmpty(this.conversationsProvider.model.current)) {
            this.getConversation(function (conversation) {
                _this.jabberEndPoints.sendChatState(new JabberSendChatStateData(conversation.uid, ChatConverter.convertToJabberJidResultData(_this._modelAuth.jid), JabberTypeVoData.GROUP_CHAT, value));
            });
        }
    };
    JabberProvider.prototype.send = function (messageVo, callback) {
        var _this = this;
        if (this._sendingTimer != null)
            clearTimeout(this._sendingTimer);
        this._sendingMessages.push(messageVo);
        this._sendingTimer = setTimeout(function () {
            for (var _i = 0, _a = _this._sendingMessages; _i < _a.length; _i++) {
                var _sendingMessage = _a[_i];
                if (_sendingMessage.valid != false) {
                    _sendingMessage.valid = false;
                    _this.messagesProvider.model.update(_sendingMessage.uid, [new UpdateModelVoData("valid", _sendingMessage.valid)]);
                }
            }
        }, 10000);
        this.getConversation(function (conversation) {
            if (CheckUtils.isEmpty(_this._modelAuth.jid) || CheckUtils.isEmpty(_this._modelAuth.jid.bare))
                return;
            _this.join(conversation);
            if (conversation.state == ConversationStateVoData.NOT_SEND) {
                _this.getNewConversationMessage(conversation, _this._modelAuth.jid.bare, function (conversationVo, messageVo) {
                    _this.conversationsProvider.model.add(conversationVo, true);
                    _this.prepareToSend(messageVo, conversation, callback);
                    if (!_this._conversationsSettingsModel.liveSupportOnline &&
                        !_this._conversationsSettingsModel.liveSupportProvided) {
                        _this._conversationsSettingsModel.setLiveSupportProvided(true);
                        setTimeout(function () {
                            if (!CheckUtils.isEmpty(_this._liveSupportProvidedHandler))
                                _this._liveSupportProvidedHandler();
                        }, 2000);
                    }
                }, messageVo);
            }
            else {
                _this.prepareToSend(messageVo, conversation, callback);
            }
        });
    };
    Object.defineProperty(JabberProvider.prototype, "onLiveSupportProvidedHandler", {
        set: function (handler) {
            this._liveSupportProvidedHandler = handler;
        },
        enumerable: true,
        configurable: true
    });
    JabberProvider.prototype.prepareToSend = function (messageVo, conversationVo, callback) {
        if (this.prepareNewConversationMessage(messageVo, conversationVo)) {
            this.messagesProvider.model.add(messageVo);
            var message = ChatConverter.convertToJabberMessageData(messageVo);
            var filesVo = CheckUtils.isEmpty(messageVo.files) ? [] :
                this._filesProvider.model.getAll(messageVo.files);
            message.properties = new JabberPropertiesData();
            message.properties.addProperty("attachments", "string", JSON.stringify(FilesConverter.convertToFilesData(filesVo)));
            message.properties.addProperty("isEdited", "string", JSON.stringify(messageVo.isEdited));
            message.properties.addProperty("isDeleted", "string", JSON.stringify(messageVo.isDeleted));
            if (!CheckUtils.isEmpty(messageVo.itemId))
                message.properties.addProperty("itemId", "long", messageVo.itemId);
            this.jabberEndPoints.sendMessage(message);
            callback(conversationVo);
        }
    };
    JabberProvider.prototype.prepareNewConversationMessage = function (messageVo, conversationVo) {
        if (CheckUtils.isEmpty(messageVo.uid))
            messageVo.uid = this.getNewMessageJabberId();
        if (!CheckUtils.isEmpty(messageVo.uid)) {
            messageVo.from = conversationVo.uid;
            if (conversationVo.messagesId.indexOf(messageVo.uid) == -1)
                conversationVo.messagesId.push(messageVo.uid);
            messageVo.source = MessageSourceVoData.JABBER;
            messageVo.type = JabberTypeVoData.GROUP_CHAT;
            if (!CheckUtils.isEmpty(this._modelAuth.jid.bare) && messageVo.authorJabberId == null)
                messageVo.authorJabberId = this._modelAuth.jid.bare;
            messageVo.to = conversationVo.uid;
            return true;
        }
        return false;
    };
    JabberProvider.prototype.getNewConversationMessage = function (conversationVo, jid, callback, messageVo) {
        var _this = this;
        this.usersProvider.resolveJids(new Set([jid]), function (res) {
            if (CheckUtils.areEmpty(conversationVo, res.get(jid)))
                return;
            if (CheckUtils.isEmpty(messageVo)) {
                messageVo = new MessageVoData();
                messageVo.createdDate = new Date().getTime();
                messageVo.authorJabberId = jid;
            }
            var conversationUserStatistics = new ConversationUserStatisticsVoData(res.get(jid).userId, res.get(jid).uid);
            conversationVo.lastPosted = messageVo.createdDate;
            conversationUserStatistics.lastPosted = conversationVo.lastPosted;
            conversationVo.usersStatictics.push(conversationUserStatistics);
            conversationVo.status = ConversationStatusVoData.OPEN;
            if (_this.prepareNewConversationMessage(messageVo, conversationVo)) {
                callback(conversationVo, messageVo);
            }
        });
    };
    JabberProvider.prototype.sendToAdmin = function (message) {
        if (message.from.resource != this._modelAuth.jid.bare)
            return;
        var adminMessage = new JabberCustomMessageData();
        adminMessage.type = JabberTypeVoData.CHAT;
        adminMessage.to = this.config.jabberAdminReceiver;
        adminMessage.body = message.body;
        var properties = adminMessage.properties = new JabberPropertiesData();
        properties.addProperty("msg_jid", "string", message.id);
        properties.addProperty("room_jid", "string", message.from.bare);
        properties.addProperty("src", "string", "CUSTOMER_PORTAL");
        properties.addProperty("created", "long", (CheckUtils.isEmpty(message.delay) || CheckUtils.isEmpty(message.delay.stamp)) ?
            new Date().getTime() : message.delay.stamp.getTime());
        properties.addProperty("org_uri", "string", this._modelOrg.uri);
        var hasAttachments = false;
        var hasItemId = false;
        if (message.hasOwnProperty("customData") && message.customData.hasOwnProperty("properties")) {
            for (var _i = 0, _a = message.customData.properties; _i < _a.length; _i++) {
                var property = _a[_i];
                if ("attachments" === property.name && !CheckUtils.isEmpty(property.value)) {
                    var attachmentKeys = "";
                    var i = 0;
                    for (var _b = 0, _c = property.value; _b < _c.length; _b++) {
                        var attachment = _c[_b];
                        attachmentKeys += attachment.identityKey;
                        if (i < property.value.length - 1)
                            attachmentKeys += ",";
                        i++;
                    }
                    properties.addProperty("attachmentKeys", "string", attachmentKeys);
                    hasAttachments = true;
                }
                else if ("itemId" === property.name && !CheckUtils.isEmpty(property.value)) {
                    properties.addProperty("itemId", "long", property.value);
                }
            }
        }
        if (!hasAttachments)
            properties.addProperty("attachmentKeys", "string", "");
        this.jabberEndPoints.sendMessage(adminMessage);
    };
    JabberProvider.prototype.checkSendToAdmin = function (adminMessage) {
        if (CheckUtils.areEmpty(adminMessage.id, adminMessage.from, adminMessage.to, adminMessage.created, adminMessage.delay)) {
            logger.error("Jabber-Provider - Error on checkSendToAdmin - some properties are empty");
        }
    };
    JabberProvider.prototype._handleConnected = function () {
        var _this = this;
        this.jabberEndPoints.onConnected(function (value) {
            if (value == null)
                _this._reconnect();
        });
    };
    JabberProvider.prototype._reconnect = function () {
        var _this = this;
        if (this._reconnectTimeout != null) {
            window.clearTimeout(this._reconnectTimeout);
            this._reconnectTimeout = undefined;
        }
        if (!this.jabberEndPoints.isConnecting && !this.jabberEndPoints.isForcedDisconnect) {
            this._reconnectTimeout = window.setTimeout(function () {
                _this._handleConnected();
                _this.jabberEndPoints.connect();
            }, this._getDelay());
            this._reconnectCount++;
        }
        else {
            this._reconnectCount = 0;
        }
    };
    JabberProvider.prototype._getDelay = function () {
        if (this._reconnectCount < 10) {
            return 1000;
        }
        else if (this._reconnectCount < 100) {
            return 60000;
        }
        else {
            return 600000;
        }
    };
    JabberProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    JabberProvider.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ["config",] },] },
        { type: Events, },
        { type: CacheService, },
        { type: ChatEndPoints, },
        { type: JabberEndPoints, },
        { type: ConversationsProvider, },
        { type: ConversationsMessagesProvider, },
        { type: UsersProvider, },
        { type: FilesProvider, },
        { type: UsersResolverModel, },
        { type: ConversationsSettingsModel, },
        { type: ConversationsStatisticsProvider, },
        { type: AuthenticationModel, },
        { type: UsersProvider, },
        { type: AuthenticationProvider, },
        { type: OrganizationModel, },
    ]; };
    return JabberProvider;
}());
export { JabberProvider };
//# sourceMappingURL=jabber-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/chat/jabber-provider.js
// module id = 253
// module chunks = 14